/* Presentation only: move existing information into native, default-closed panels. */
(() => {
  if (window.ohmmProductInformationLoaded) return;
  window.ohmmProductInformationLoaded = true;
  const headingTag = /^H[2-6]$/;
  const policyText = /return shipping|original packaging|return unused items|14\s*(?:calendar\s*)?days\s*(?:of|from|after)\s*delivery|devoluci[oó]n.*14|embalaje original/i;
  const policyHeading = /shipping\s*(?:&|and)\s*returns|return\s*(?:policy|conditions)|refund\s*policy|env[ií]os?\s*(?:y|&)\s*devoluciones|pol[ií]tica\s*de\s*devoluci[oó]n/i;
  const language = document.documentElement.lang.startsWith('es') ? 'es' : 'en';
  const labels = language === 'es'
    ? {shipping:'Envíos y devoluciones', included:'Qué incluye', details:'Detalles del producto'}
    : {shipping:'Shipping & returns', included:"What's included", details:'Product details'};
  function panel(title, before) {
    const details = document.createElement('details');
    details.className = 'ohmm-information-panel';
    const summary = document.createElement('summary');
    summary.textContent = title;
    const content = document.createElement('div');
    content.className = 'ohmm-information-panel__content';
    details.append(summary, content);
    before.before(details);
    return {details, content};
  }
  function description(root) {
    if (root.dataset.ohmmInformation === 'true') return;
    root.dataset.ohmmInformation = 'true';
    [...root.children].filter(el => headingTag.test(el.tagName)).forEach(heading => {
      const title = heading.textContent.trim();
      if (!title) return;
      const group = panel(title, heading);
      heading.remove();
      while (group.details.nextSibling && !headingTag.test(group.details.nextSibling.nodeName)) {
        group.content.append(group.details.nextSibling);
      }
    });
    /* Descriptions without headings: leave the opening introduction, collapse lists/tables. */
    [...root.children].filter(el => ['UL','OL','TABLE'].includes(el.tagName)).forEach(el => {
      panel(labels.details, el).content.append(el);
    });
    [...root.children].filter(el => el.tagName === 'P').forEach(el => {
      if (el.textContent.length > 120 && (policyText.test(el.textContent) || el.querySelector('a[href*="/policies/refund-policy"]'))) {
        panel(labels.shipping, el).content.append(el);
      }
    });
    root.querySelectorAll(':scope > .ohmm-description-return').forEach(el => {
      el.classList.add('ohmm-information-panel');
    });
  }
  function buyBox(root) {
    const returnPanel = root.querySelector('.ohmm-return-tabs__panel');
    if (returnPanel) {
      const returnBody = returnPanel.querySelector('.ohmm-return-tabs__content');
      root.querySelectorAll('.ohmm-information-panel, .ohmm-earbuds-shipping').forEach(deliveryPanel => {
        if (!returnBody || !deliveryPanel.querySelector('.ohmm-delivery-note, .ohmm-earbuds-shipping__content')) return;
        const deliveryBody = deliveryPanel.querySelector('.ohmm-information-panel__content, .ohmm-earbuds-shipping__content');
        if (!deliveryBody) return;
        returnBody.prepend(deliveryBody);
        deliveryPanel.remove();
        returnPanel.querySelector(':scope > summary').textContent = labels.shipping;
      });
    }
    /* Fold any remaining legacy delivery/package block; do not touch price or pack selectors. */
    root.querySelectorAll('.ohmm-delivery-note, .ohmm-star-included').forEach(el => {
      if (el.closest('details')) return;
      const shipping = root.querySelector('.ohmm-return-tabs__panel');
      if (shipping) {
        shipping.querySelector(':scope > summary').textContent = labels.shipping;
        const body = shipping.querySelector('.ohmm-return-tabs__content');
        if (body) body.prepend(el);
      } else {
        panel(el.matches('.ohmm-star-included') ? labels.included : labels.shipping, el).content.append(el);
      }
    });
    /* Repair a legacy policy summary outside an accordion, without deleting its conditions. */
    root.querySelectorAll('.ohmm-policy-summary').forEach(el => {
      if (!el.closest('details')) panel(labels.shipping, el).content.append(el);
    });
    root.querySelectorAll('p').forEach(el => {
      if (el.closest('details') || el.closest('.product__description') || el.closest('.jdgm-widget') || el.children.length > 8) return;
      if (el.textContent.length > 120 && policyText.test(el.textContent)) panel(labels.shipping, el).content.append(el);
    });
    root.querySelectorAll('details').forEach(el => {
      const summary = el.querySelector(':scope > summary');
      if (summary && policyHeading.test(summary.textContent)) el.removeAttribute('open');
    });
  }
  function init() {
    document.querySelectorAll('.product__description').forEach(description);
    document.querySelectorAll('.product__info-container').forEach(buyBox);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
